import { IncidentDetailPatient } from '../useIncidentDetailForHiroshima';
import { HiroshimaPatientDetailTabKey } from '..';
import { FC } from 'react';
import { BaseInfoView } from './BaseInfoView';
import { RequestSummaryView } from './RequestSummaryView';
import { FindingsEmsTeamContactView } from './FindingsEmsTeamContactView';
import { VitalsView } from './VitalsView';
import { SpecialTreatmentView } from './SpecialTreatmentView';
import { IncidentSituationView } from './IncidentSituationView';
import { CPAModeView } from './CPAModeView';
import { NotesView } from './NotesView';
import { Photo } from 'core/components/JianDetail/PatientDetailInfo/Photo';
import { DocumentsView } from './DocumentsView';
import { AcceptRequestHistory } from 'core/components/JianDetail/PatientDetailInfo/AcceptRequestHistory';

type Props = {
  patient: IncidentDetailPatient;
  selectedTab: HiroshimaPatientDetailTabKey;
};

export const PatientDetailSection: FC<Props> = ({ patient, selectedTab }) => {
  return (
    <div className="pt-[24px] pb-[40px]">
      <div className="max-w-[1280px] px-[40px] m-auto">
        {selectedTab === 'baseInfo' && (
          <BaseInfoView
            baseInfo={patient.baseInfo}
            determinedHospitalName={patient.determinedHospitalName}
          />
        )}
        {selectedTab === 'requestSummary' && (
          <RequestSummaryView requestSummary={patient.requestSummary} />
        )}
        {selectedTab === 'findingsEmsContact' && (
          <FindingsEmsTeamContactView
            findingsEmsTeamContact={patient.findingsEmsContact}
          />
        )}
        {selectedTab === 'vitals' && <VitalsView vitals={patient.vitals} />}
        {selectedTab === 'photo' && <Photo images={patient.imageIds} />}
        {selectedTab === 'specialTreatment' && (
          <SpecialTreatmentView
            specialTreatment={patient.treatments[0]?.data}
          />
        )}
        {selectedTab === 'incidentSituation' && (
          <IncidentSituationView data={patient.incidentSituation} />
        )}
        {selectedTab === 'cpaMode' && (
          <CPAModeView isCpa={patient.isCpa ?? false} data={patient.cpaData} />
        )}
        {selectedTab === 'note' && <NotesView note={patient.note} />}
        {selectedTab === 'acceptRequestHistory' && (
          <AcceptRequestHistory
            acceptRequestHistory={patient.acceptRequestHistory}
          />
        )}
        {selectedTab === 'documents' && (
          <DocumentsView
            activityRecordPdf={patient.activityRecordPdf}
            nonTransportPdf={patient.nonTransportPdf}
          />
        )}
      </div>
    </div>
  );
};
